import React from 'react';
import {Link} from 'react-router-dom';
import i18n from 'i18n-react';
import Slider from 'react-slick';
import slider1 from '../images/slide1.png';
import logoVio from '../images/logo-vio.png';
import dot2 from '../images/dot2.png';
export default class HomeSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: this.props.locale,
      windowHeight: window.innerHeight - 100
    };
    this.sliderStyle = {
      height: this.state.windowHeight + 'px'
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResizeHandler.bind(this));
  }

  onResizeHandler() {
    this.setState({windowHeight: window.innerHeight - 100});
    this.sliderStyle = {
      height: this.state.windowHeight + 'px'
    };
  }

  render() {
    let settings = {
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    };
    return (
      <div className="slider">
        <Slider {...settings}>
          <div className="slide slide1" style={this.sliderStyle}>
            <div className="content">
              <div className="row">{this.state.locale}<img src={dot2} className="dot activo" alt=""/></div>
              <div className="row"><img src={slider1} className="banner" alt=""/></div>
              <div className="row">
                <Link to="#" className="boton">
                  <i18n.span text={{key: this.state.locale + ".home.slides.boton1"}}/>
                </Link> <img src={logoVio} className="logo" alt=""/>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/HomeSlider.js